import { render, staticRenderFns } from "./dealerctradeSoftware.vue?vue&type=template&id=54298b70&scoped=true"
import script from "./dealerctradeSoftware.vue?vue&type=script&lang=js"
export * from "./dealerctradeSoftware.vue?vue&type=script&lang=js"
import style0 from "./dealerctradeSoftware.vue?vue&type=style&index=0&id=54298b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54298b70",
  null
  
)

export default component.exports